import { Table as TanTable } from '@tanstack/react-table';

const toCssWidth = (width: number | undefined) => (width ? `${width}px` : undefined);

export const useFixedHeaderColumnsLayout = <D extends object = object>(table: TanTable<D>) => {
  const [firstHeaderGroup] = table.getHeaderGroups();
  const [firstHeader, ...restHeaders] = firstHeaderGroup.headers;

  return {
    firstHeader,
    restHeaders,
    firstColumnWidth: toCssWidth(firstHeader.column.columnDef.size),
    scrollableColumnsTemplate: restHeaders
      .map((header) => toCssWidth(header.column.columnDef.size) ?? 'minmax(var(--min-col-width, 112px), 1fr)')
      .join(' '),
    scrollableContentWidth: restHeaders.length
      ? `${restHeaders.reduce((total, header) => total + (header.getSize() || 112), 0)}px`
      : undefined,
  };
};
